import ElectricCarIcon from '@mui/icons-material/ElectricCar'
import dayjs from 'dayjs'
import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { AppContext } from '../../../../contexts/AppContext'
import { useConsumptionElementData } from '../../../../contexts/hooks/useConsumptionElementData'
import useUser from '../../../../contexts/hooks/useUser'
import { trpc } from '../../../../modules/trpc'
import { useElectronicCar } from '../../../devices/electricCar/hooks/useEletronicCar'
import { useChartTime } from '../../../electricity/chartUtils/hooks/useChartTime'
import OverViewCard from '../OverviewCard'
import CarStateBar from './components/CarStateBar'
import DisplayInfo from './components/DisplayInfo'

const CarStateCard = () => {
	const { isDarkMode } = useContext(AppContext)
	const history = useHistory()

	const { user } = useUser()

	const time = useChartTime('month')
	const data = useConsumptionElementData(time.startTime, time.endTime)

	const { t } = useTranslation('pages_overview')

	if (!user?.vehicleLinked) return null

	const { data: vehicles, isLoading } = trpc.eNode.vehicles.get.useQuery({
		hashedPid: user?.hashedPid || '',
	})

	const electronicCarHook = useElectronicCar((vehicles && vehicles[0]?.id) || '')

	if (!electronicCarHook) return null

	const { vehicle, smartChargingStatus, vehicleLoading } = electronicCarHook

	const element = useMemo(() => {
		return data.data.find(consumptionElement => {
			if (consumptionElement.eNodeId === vehicle?.id) {
				return consumptionElement
			}
		})
	}, [data])

	if (!element) return <></>

	const handleClick = () => {
		history.push(`/devices/electric-car/${vehicle?.id || ''}`, { element })
	}

	if (isLoading || vehicleLoading || !vehicle) return null

	const { batteryLevel, range, isFullyCharged, chargeLimit } = vehicle.chargeState

	const chargeStatusText = () => {
		if (!smartChargingStatus) return '-'

		const { state, plan } = smartChargingStatus

		if (plan?.startAt && plan?.estimatedFinishAt)
			return `${dayjs(plan.startAt).format('HH:mm')}-${dayjs(plan.estimatedFinishAt).format(
				'HH:mm'
			)}`

		if (state.split(':')[2] === 'FINISHED') return t('carStateCard.ladattu')

		return '-'
	}

	return (
		<div onClick={handleClick}>
			<OverViewCard
				headerText={t('carStateCard.otsikko')}
				icon={<ElectricCarIcon />}
				iconType='mui'
				className='car-state-card'
			>
				<div className='card-content'>
					<CarStateBar
						darkModeEnabled={isDarkMode}
						batteryLevel={batteryLevel ?? 0}
						chargeLimit={chargeLimit ?? 0}
						isFullyCharged={isFullyCharged ?? false}
					/>
					<div className='info'>
						<DisplayInfo title={t('carStateCard.akku')} text={`${batteryLevel}%`} divider={true} />
						<DisplayInfo
							title={t('carStateCard.arvio')}
							text={`${Math.round(range ?? 0)} km`}
							divider={true}
						/>
						<DisplayInfo title={t('carStateCard.tila')} text={chargeStatusText()} />
					</div>
				</div>
			</OverViewCard>
		</div>
	)
}

export default CarStateCard
